import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

export const searchAttributes = [
  'body',
  'body_summarized',
  'image_alt',
  'link_text',
  'labels_name',
  'paragraphs_body',
  'paragraphs_entity_name',
  'paragraphs_entity_title',
  'page_title',
  'first_name',
  'last_name',
];

export const resultAttributes = [
  // General.
  'image_ratio_1_1_xxs',
  'image_ratio_1_1_xs',
  'image_ratio_1_1_sm',
  'image_ratio_1_1_md',

  'profile_image_ratio_1_1_sxs',
  'profile_image_ratio_1_1_xs',
  'profile_image_ratio_1_1_sm',
  'profile_image_ratio_1_1_md',

  'image_ratio_3_2_xxs',
  'image_ratio_3_2_xs',
  'image_ratio_3_2_sm',
  'image_ratio_3_2_md',

  'image_ratio_3_4_xxs',
  'image_ratio_3_4_xs',
  'image_ratio_3_4_sm',
  'image_ratio_3_4_md',

  'image_ratio_4_3_xxs',
  'image_ratio_4_3_xs',
  'image_ratio_4_3_sm',
  'image_ratio_4_3_md',

  'image_ratio_16_9_xxs',
  'image_ratio_16_9_xs',
  'image_ratio_16_9_sm',
  'image_ratio_16_9_md',

  'url',

  // Content.
  'article_type_name',
  'article_type_tid',
  'authored_by_uid',
  'body_summarized',
  'body',
  'content_type',
  'created',
  'employment_types',
  'entity_type',
  'first_name',
  'image_alt',
  'labels_name',
  'labels_tid',
  'link_text',
  'link_url',
  'nid',
  'page_title',
  'paragraph_type',
  'paragraphs_body',
  'paragraphs_entity_name',
  'paragraphs_entity_title',
  'profile_id',
  'profile_type',
  'project_status_name',
  'project_status_tid',
  'project_types_name',
  'project_types_tid',
  'promoted_to_frontpage',
  'publish_date',
  'vacancy_function_name',
  'vacancy_locations_name',
];

export const highlightAttributes = [
  'body',
  'body_summarized',
  'page_title',
  'first_name',
  'last_name',
];

export const facetAttributes: Exclude<SearchkitWrapperProps['searchSettings']['facet_attributes'], undefined> = [
  {
    attribute: 'content_type',
    field: 'content_type',
    type: 'string',
  },
  {
    attribute: 'profile_type',
    field: 'profile_type',
    type: 'string',
  },
  {
    attribute: 'project_status_name',
    field: 'project_status_name',
    type: 'string',
  },
  {
    attribute: 'project_types_name',
    field: 'project_types_name',
    type: 'string',
  },
  {
    attribute: 'article_type_name',
    field: 'article_type_name',
    type: 'string',
  },
];

export const sorting: Exclude<SearchkitWrapperProps['searchSettings']['sorting'], undefined> = {
  default: {
    field: '_score',
    order: 'desc',
  },
  _created_asc: {
    field: 'created',
    order: 'asc',
  },
  _created_desc: {
    field: 'created',
    order: 'desc',
  },
};
